import React from 'react';
import cx from 'classnames';
import { capitalize } from 'lodash-es';

import styles from './ButtonSmall.module.scss';

interface IButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'action';
  className?: string;
}

const ButtonSmall = ({
  variant = 'primary',
  children,
  className,
  ...attributes
}: IButtonProps & React.HTMLProps<HTMLButtonElement>): JSX.Element => {
  return (
    <button
      {...attributes}
      className={cx(styles.button, styles[`button${capitalize(variant)}`], className)}
      type="button"
    >
      {children}
    </button>
  );
};

export default ButtonSmall;
